import { FinancialAccountPrimaryUse } from '@/reducers/finances/financialAccountsReducer'

/**
 * Builds the column-backed half of the designation save. Each follow-up bool is only
 * meaningful in one direction — personal charges on a business account, business charges
 * on a personal one — so only the matching one is written, and only once answered.
 */
export const buildDesignationUpdate = ({
  isBusinessAccount,
  hasPersonalTransactions,
  hasBusinessTransactions,
}: {
  isBusinessAccount: boolean | undefined
  hasPersonalTransactions?: boolean
  hasBusinessTransactions?: boolean
}): {
  primaryUse?: FinancialAccountPrimaryUse
  hasPersonalTransactions?: boolean
  hasBusinessTransactions?: boolean
} => {
  if (isBusinessAccount === undefined) {
    return {}
  }

  if (isBusinessAccount) {
    return hasPersonalTransactions === undefined
      ? { primaryUse: FinancialAccountPrimaryUse.BUSINESS }
      : {
          primaryUse: FinancialAccountPrimaryUse.BUSINESS,
          hasPersonalTransactions,
        }
  }

  return hasBusinessTransactions === undefined
    ? { primaryUse: FinancialAccountPrimaryUse.PERSONAL }
    : {
        primaryUse: FinancialAccountPrimaryUse.PERSONAL,
        hasBusinessTransactions,
      }
}
